/**
 * Registers test utilities on the global window object for use in the Kitchen Sink test environment.
 * Dispatches a custom event to notify consumers when the API is ready.
 *
 * Registration only occurs when BOTH conditions are met:
 * 1. IS_WHISPER_BUNDLE is true (set via webpack DefinePlugin in Whisper bundle)
 * 2. Running in Kitchen Sink environment (window.hubspot.bender.currentProject matches)
 *
 * This ensures the test API comes from the Whisper bundle, not from Kitchen Sink's own imports,
 * allowing testing of version differences between Whisper and the host app.
 *
 * @param api - Object containing test utility functions to expose (e.g., { orchestratorStorage })
 *
 * Usage:
 *   registerTestApi({ orchestratorStorage });
 *
 * Consumers can listen for the ready event:
 *   window.addEventListener('orchestrator:testApiReady', (event) => {
 *     // API is now available on window.__orchestratorTestAPI
 *   });
 */
export const registerTestApi = api => {
  var _window$hubspot;
  // Only register if loaded from Whisper bundle (via DefinePlugin)
  // @ts-ignore - IS_WHISPER_BUNDLE is defined via DefinePlugin
  if (typeof IS_WHISPER_BUNDLE === 'undefined' || IS_WHISPER_BUNDLE !== true) {
    return;
  }

  // Only register the test API if we're in the kitchen sink project
  if (
  // @ts-ignore - bender is not typed
  ((_window$hubspot = window.hubspot) === null || _window$hubspot === void 0 || (_window$hubspot = _window$hubspot.bender) === null || _window$hubspot === void 0 ? void 0 : _window$hubspot.currentProject) !== 'central-engagement-orchestrator-kitchen-sink') {
    return;
  }

  // Expose the API on the global window object for test access
  window.__orchestratorTestAPI = Object.assign({}, window.__orchestratorTestAPI, api);

  // Dispatch event to notify consumers that the API is ready
  window.dispatchEvent(new CustomEvent('orchestrator:testApiReady', {
    detail: {
      apiNames: Object.keys(api)
    }
  }));
};